import { FormControl, FormControlLabel, FormHelperText, Switch, Theme } from "@mui/material";
import React from 'react';
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";
import { SxProps } from "@mui/system";

export type SideSheetSwitchProps = {
    checked: boolean;
    sxLabel?: SxProps<Theme>;
    onChange?: (checked: boolean) => void | undefined;
} & SideSheetFieldPropsBase;

export default function SideSheetSwitch({
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    sx,
    sxLabel,
    disabled,
    checked,
    onChange
}: SideSheetSwitchProps) {

    return (
        <FormControl
            aria-label={ariaLabel}
            sx={{
                marginTop: 0,
                ...sx
            }}>
            <FormControlLabel
                aria-label={ariaLabel}
                sx={{
                    marginTop: 0,
                    marginRight: 0,
                    marginLeft: 0,
                    ...sxLabel
                }}
                control={
                    <Switch //color="primary"
                        id={id}
                        data-testid={testId}
                        checked={checked}
                        readOnly={readOnly}
                        onChange={(_event, checked) => {
                            onChange && onChange(checked);
                        }}
                        disabled={disabled}
                    />}
                label={label ?? ''}
                labelPlacement="start"
                slotProps={{
                    typography: {
                        sx: {
                            marginRight: "auto"
                        }
                    }
                }}
            />
            {helperText &&
                <FormHelperText>{helperText}</FormHelperText>
            }
        </FormControl>
    );
}